module.exports = __webpack_public_path__ + "img/6-4.23beaa2c.png";